import Nullstack from 'nullstack';
export default function IconDeviceMobileVibration({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-device-mobile-vibration",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "3",
    width: "12",
    height: "18",
    rx: "2"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "4",
    x2: "10",
    y2: "4"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "17",
    x2: "9",
    y2: "17.01"
  }), "   ", Nullstack.element("path", {
    d: "M21 6l-2 3l2 3l-2 3l2 3"
  }), " ");
}